import { IIngredient } from "../../types/recipe";
import { getApi } from "../api";
import { IngredientDb } from "../indexeddb/ingredientDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class IngredientStore {
  private static instance: IngredientStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new IngredientDb();
  public ingredients: IIngredient[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): IngredientStore {
    if (!IngredientStore.instance) {
        IngredientStore.instance = new IngredientStore();
    }
    return IngredientStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
    await this.getIngredients();
  }

  public async getIngredients(clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getIngredients();
      if (local.length === 0 || clear) {
        const api = await getApi(apiUrl, "ingredient", apiToken);
        await this.db.addIngredients(api, clear);
        this.ingredients = api;
      } else {
        this.ingredients = local;
      }
    } catch (e: any) {
      console.log(e);
    }
  }
}
